/* ============================================================
   LEMAJ RAYMÒN — CONCEPT D THEME JS
   ============================================================ */

(function () {
  'use strict';

  /* ── Sticky header shadow ── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ── Scroll reveal ── */
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(el => observer.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('visible'));
  }

  /* ── Mobile menu ── */
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-overlay');
  const mobileClose = document.getElementById('mobile-menu-close');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    mobileOverlay.classList.add('open');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    mobileOverlay.classList.remove('open');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMenu);

  /* ── Product gallery thumbnails ── */
  const thumbs = document.querySelectorAll('.product-main__thumb');
  const imgs = document.querySelectorAll('.product-main__img');
  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      imgs.forEach(im => im.classList.remove('active'));
      thumb.classList.add('active');
      if (imgs[i]) imgs[i].classList.add('active');
    });
  });

  /* ── Product variant selector ── */
  const variantBtns = document.querySelectorAll('.product-main__option-btn');
  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.product-main__option-values');
      group.querySelectorAll('.product-main__option-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  /* ── Quick add to cart ── */
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        const countEl = document.querySelector('.nav__cart-count');
        if (countEl) countEl.textContent = parseInt(countEl.textContent || 0) + 1;
        btn.textContent = 'Added!';
        setTimeout(() => { btn.innerHTML = btn.dataset.variantId ? 'Add to Bag &rarr;' : 'Configure &rarr;'; }, 1800);
      })
      .catch(err => console.error('Cart error:', err));
    });

    btn.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }
    });
  });

  /* ── Cart quantity update ── */
  let cartUpdateTimer;
  document.querySelectorAll('.cart-main__qty-input').forEach(input => {
    input.addEventListener('change', () => {
      clearTimeout(cartUpdateTimer);
      cartUpdateTimer = setTimeout(() => {
        const form = input.closest('form');
        if (form) form.submit();
      }, 600);
    });
  });

  /* ── Smooth scroll for anchor links ── */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
